var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2281 2.41445C11.3456 1.86185 12.6568 1.86185 13.7743 2.41445L19.7755 5.38214C21.1393 6.05655 22.0025 7.44625 22.0025 8.96769V15.0339C22.0025 16.5553 21.1393 17.945 19.7755 18.6194L13.7743 21.5871C12.6568 22.1397 11.3456 22.1397 10.2281 21.5871L4.22679 18.6194C2.86299 17.945 1.99988 16.5553 1.99988 15.0339V8.96769C1.99988 7.44625 2.863 6.05655 4.22679 5.38214L10.2281 2.41445ZM12.8877 4.20723C12.329 3.93092 11.6734 3.93093 11.1146 4.20723L5.11333 7.17492C5.02997 7.21614 4.95034 7.26271 4.87479 7.31409L11.1044 10.4333C11.668 10.7155 12.3317 10.7155 12.8953 10.4333L19.1264 7.31335C19.0512 7.26226 18.972 7.21594 18.889 7.17492L12.8877 4.20723ZM3.99988 15.0339V9.11272L10.209 12.2217C10.4642 12.3495 10.7297 12.4483 11.0009 12.5182L11.0009 19.7381L5.11333 16.8267C4.43144 16.4895 3.99988 15.7946 3.99988 15.0339ZM13.0009 19.7384L18.889 16.8267C19.5709 16.4895 20.0025 15.7946 20.0025 15.0339V9.11143L13.7908 12.2217C13.5361 12.3492 13.2713 12.4479 13.0009 12.5177L13.0009 19.7384Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTab);
export default __webpack_public_path__ + "static/media/audit-tab.4c793387.svg";
export { ForwardRef as ReactComponent };